module.exports = __webpack_public_path__ + "media/packs/images/flags/CH-ab9683fcd4edda9ac057afffee5242b2.png";